export const IS_HEADER = ["/", "/ranking", "/setting", "/goal", "/plogging", "/post", "/score", "/calendar"];
